const check = {
  ManualPunch: {
    pending: '/check/manual-punch'
    // history: '/check/manual-punch/history'
  }
};

export default check;
